import moment from 'moment';
import momentPropTypes from 'react-moment-proptypes';
import PropTypes from 'prop-types';
import React from 'react';

export default function CalendarDay({
  className, day, renderDayContents, onClick,
}) {
  if (!day) return <div className={className} />;

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onClick(day);
    }
  };

  const handleClick = () => {
    onClick(day);
  };

  return (
    <div className={className} role="button" tabIndex={0} onClick={handleClick} onKeyPress={handleKeyPress}>
      {renderDayContents ? renderDayContents(day) : day.format('D')}
    </div>
  );
}

CalendarDay.propTypes = {
  className: PropTypes.string,
  day: momentPropTypes.momentObj,
  renderDayContents: PropTypes.func,
  onClick: PropTypes.func,
};

CalendarDay.defaultProps = {
  className: undefined,
  day: moment(),
  renderDayContents: undefined,
  onClick: () => {},
};
